import { Box, Card, CardActionArea, CardContent, Chip, Typography } from '@mui/material'
import { useState } from 'react'
import CustomerExportReportDialog from './CustomerExportReportDialog'

export default function CustomerExportReportCard() {
  const [dialogOpen, setDialogOpen] = useState(false)

  return (
    <>
      <Card
        id='customer-export-report-card'
        sx={{
          height: 180,
          transition: theme => theme.transitions.create(['box-shadow', 'transform']),
          '&:hover': {
            boxShadow: 6,
            transform: 'translateY(-2px)'
          }
        }}
      >
        <CardActionArea id='customer-export-report-open' onClick={() => setDialogOpen(true)} sx={{ height: '100%' }}>
          <CardContent sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
            <Box alignItems='center' display='flex' gap={1} mb={1}>
              <Typography fontWeight='bold' variant='h6'>
                Customer Export Report
              </Typography>

              <Chip color='primary' label='.csv' size='small' variant='outlined' />
            </Box>

            <Typography variant='body2'>
              Download all vehicles for the selected Exporter / Buyer.
            </Typography>
          </CardContent>
        </CardActionArea>
      </Card>

      <CustomerExportReportDialog open={dialogOpen} onClose={() => setDialogOpen(false)} />
    </>
  )
}
